const getPaymentMethodCode = require('./getPaymentMethodCode');

module.exports = function({ payments, includeUnchargedOnlinePayments = true, includeCredits = true, methodName, initial = false }){

  return payments
  .filter(p => {
    return p.status !== 2;
  })
    .filter(p => {
      if(methodName){
        let methodCode = getPaymentMethodCode(methodName);
        return p.method = methodCode;
      }
      return !includeCredits 
        ? p.code !== getPaymentMethodCode('credit')
        : true;
    })
    .reduce((acc, payment) => {

      let amount = initial
        ? payment.amount
        : typeof payment.amount_received !== 'undefined'
          ? payment.amount_received - (payment.amount_refunded || 0)
          : typeof payment.amount_expected !== 'undefined'
            ? payment.amount_expected
            : payment.amount;

      if(payment.method !== getPaymentMethodCode('online')){
        acc += amount;
      }
      else if(payment.create_success){
        if(
          (
            typeof payment.debit_success === 'undefined'
            && includeUnchargedOnlinePayments
          ) 
          || payment.debit_success
        ){
          acc += amount;
        }
      }
      return acc;
    },
    0);
};